import axios from 'axios';
import router from '../router';

const state = {
// users state
  products: []
};

const mutations = {
// users mutations
    SET_PRODUCTS(state, products) {
        state.products = products;
    }
};

const actions = {
  async fetchProducts({ commit }, { search }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
        throw new Error('No token found'); // Handle absence of token
    }
    
    try {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || 'https://api.goerlev-station.dk/api';
        const response = await axios.get(`${baseUrl}/products`, {
            headers: { Authorization: `Bearer ${userToken}` },
            params: { search } // Include search parameter in request
        });
        commit('SET_PRODUCTS', response.data); // Update Vuex store with users
    } catch (error) {
        console.error('Error fetching products:', error); // Log any errors
        throw error; // Handle error in your components
    }
  },
  async getProductByID({ commit }, productId) { // Change from destructuring to direct variable
    console.log('Fetching product with ID:', productId);
    const userToken = localStorage.getItem('userToken'); 
    if (!userToken) {
        router.push({ name: 'login' });
        return;
    }

    try {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || 'https://api.goerlev-station.dk/api';
        const response = await axios.get(`${baseUrl}/products/${productId}`, {
            headers: { Authorization: `Bearer ${userToken}` }
        });
        console.log('Product fetch response:', response.data);
        commit('SET_PRODUCTS', response.data);
    } catch (error) {
        console.error('Error fetching product:', error);
        throw error;
    }
  },
  async createProduct({ dispatch }, { product }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      // Make sure product includes 'image' and 'imageName'
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      await axios.post(`${baseUrl}/products`, product, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      console.log('Product created:', product);
      dispatch('fetchProducts', { search: '' });
    } catch (error) {
      console.error('Error creating product:', error);
      throw error; // rethrow for component to handle
    }
  },
  async updateProduct({ dispatch }, { product, imageFile }) {
    console.log('Updating product:', product);
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      if (imageFile) {
        // Read the file as base64
        const reader = new FileReader();
        await new Promise((resolve, reject) => {
          reader.readAsDataURL(imageFile);
          reader.onload = () => resolve();
          reader.onerror = reject;
        });
        const imageData = reader.result.split(',')[1]; // Strip out data URL prefix
        product.image = imageData; // Assign base64 string to product
        product.imageName = imageFile.name; // Assign filename
      }

      // Send the data
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'https://api.goerlev-station.dk/api';
      await axios.put(`${baseUrl}/products/${product.id}`, {
        product,
        imageName: product.imageName, // send filename explicitly
      }, {
        headers: { Authorization: `Bearer ${userToken}` },
      });

      console.log('Product updated:', product);
      dispatch('fetchProducts', { search: '' });
    } catch (error) {
      console.error('Error updating product:', error);
      throw error;
    }
  },
  async deleteProduct({ dispatch }, { product }) {
    console.log('Deleting product:', product);
    const userToken = localStorage.getItem('userToken');
    console.log('User token:', userToken);
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      await axios.delete(`${baseUrl}/products/${product.id}`,
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
      console.log('Product deleted:', product.id);
      dispatch('fetchProducts', { search: '' });
    } catch (error) {
      console.error('Error deleting product:', error);
      throw error; // Rethrow the error to handle it in the component
    }
  }  
};

const getters = {
// users getters
};
    
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};